import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import clsx from 'clsx';

import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import logo from '../images/sla-logo.png';
import './ResetPassword.scss';
import { authFetch } from '../services/authFetch';
import InputValidationError from './InputValidationError';

function ForgotPassword() {
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors },
        getValues,
    } = useForm({ mode: 'all' });

    const [isLoading, setIsLoading] = useState(false);

    function handleForgotPassword() {
        const formData = new FormData();
        const { username, email } = getValues();

        formData.append('username', username);
        formData.append('email', email);

        setIsLoading(true);
        authFetch(
            `${window.AnalyticsPortalConfig.apiAddress}/PortalSessions/forgot-password`,
            {
                method: 'POST',
                body: formData,
            }
        )
            .then(response => {
                if (response.ok) {
                    toast.success('Thank you. If a matching user record is found, you will receive an e-mail message containing details to reset your password.');
                    navigate('/login');
                } else {
                    if (response.status === 403) {
                        toast.error('Incorrect password. Please try again.');
                    } else if (response.status === 401) {
                        return response.text();
                    }
                }
            })
            .then(errorText => {
                // inform the user of potential errors
                toast.error(errorText);
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => setIsLoading(false));
    }

    function handleCancel() {
        navigate('/login');
    }

    return (
        <div className="container-fluid h-100">
            <div className="row h-100">
                <div className="col-12 col-lg-6 order-2 order-lg-1 align-self-center">
                    <div id="login-form-wrapper" className="mx-auto">
                        <form onSubmit={handleSubmit(handleForgotPassword)}>
                            <h4 id="login-header" className="mb-3">
                                Forgot your password?
                            </h4>

                            <div className="form-group mb-4">
                                <label htmlFor="username">Username</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="username"
                                    placeholder="john.smith"
                                    autoComplete="username"
                                    {...register('username', { required: true })}
                                />
                                <InputValidationError
                                    error={errors.username}
                                    messages={{ required: "Required" }}
                                />
                            </div>

                            <div className="form-group mb-4">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    placeholder="name@example.com"
                                    autoComplete="email"
                                    {...register('email', {
                                        required: true,
                                        validate: {
                                            validEmail: val =>
                                                val.includes('@') && val.includes('.'),
                                        },
                                    })}
                                />
                                <InputValidationError
                                    error={errors.email}
                                    messages={{
                                        required: "Required",
                                        validEmail: "Please enter a valid email"
                                    }}
                                />
                            </div>

                            <div className="d-flex justify-content-between">
                                <button
                                    id="change-password-button"
                                    type="submit"
                                    className="btn btn-primary btn-block mt-4 mr-1"
                                    disabled={isLoading}
                                >
                                    Submit
                                </button>
                                <button
                                    id="cancel-button"
                                    type="button"
                                    className="btn btn-secondary btn-block mt-4 ml-1"
                                    onClick={handleCancel}
                                    disabled={isLoading}
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div
                    id="login-graphic-container"
                    className="col-12 col-lg-6 order-1 order-lg-2"
                >
                    <img src={logo} alt="SLA Analytics Logo" />
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
